/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as CommonTypes from './common-types'

export const CountryCode = {
	Is: 'IS',
	No: 'NO',
	Dk: 'DK',
	Se: 'SE',
	Fi: 'FI'
} as const
export type CountryCodeType = (typeof CountryCode)[keyof typeof CountryCode]
export type TaxRate = {
	uuid: string
	name: string
	code: string
	rate: CommonTypes.Amount
}
export type Country = {
	name: string
	code: CountryCodeType
	taxRates: TaxRate[]
}

export const zCountryCode = z.enum(['IS', 'NO', 'DK', 'SE', 'FI'])
export const zTaxRate = z.object({
	uuid: z.string(),
	name: z.string(),
	code: z.string(),
	rate: CommonTypes.zAmount
})
export const zCountry = z.object({
	name: z.string(),
	code: zCountryCode,
	taxRates: z.array(zTaxRate)
})
